<script lang="ts" setup>
import ContactFields from '@/components/common/ContactFields.vue';
import { Contact } from '@/models/contact.model';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Array as PropType<Contact[]>,
    required: true,
    default: () => [],
  },
  disabled: {
    type: Boolean,
  },
});

const contacts = ref<Contact[]>([...(props.modelValue || [])]);

const emit = defineEmits(['update:modelValue', 'change', 'remove']);

function update(v: Contact[]) {
  emit('update:modelValue', v);
  emit('change', v);
}

function addContact() {
  contacts.value = [
    ...(contacts.value || []),
    {
      id: -1,
      firstName: '',
      lastName: '',
      language: 'nl',
      email: '',
      phone: '',
      url: '',
      main: false,
    },
  ];
}

function removeContact(index: number) {
  const item = contacts.value[index];

  if (item.id !== -1) {
    emit('remove', item);
  }

  contacts.value.splice(index, 1);
}

watch(
  () => props.modelValue,
  () => {
    contacts.value = [...(props.modelValue || [])];
  },
);
</script>
<template>
  <h3>{{ $t('initiative.edit.contacts', { count: contacts.length }) }}</h3>
  <ContactFields
    v-for="(a, index) in contacts || []"
    :label="`${$t('initiative.edit.contact')} ${index + 1}`"
    removable
    @remove="removeContact(index)"
    :key="index"
    v-model="contacts[index]"
    :disabled="disabled"
    @update:model-value="
      (v) =>
        update([...contacts.slice(0, index), v, ...contacts.slice(index + 1)])
    "
  />
  <br />
  <v-btn v-if="!disabled" @click="addContact">{{
    $t('initiative.edit.addContact')
  }}</v-btn
  ><br />
  <br />
</template>
